<template>
    <div>
        <div class="xinz">
            <div class="right">
                <el-button type="warning" @click="addCustTask" v-if="addCustTask"><i class="fa fa-plus" /> {{$t('m.t_newTask')}}</el-button>
            </div>
        </div>
        <div>
            <el-form :inline="true"  class="demo-form-inline" @keyup.native.enter="getTaskList" size="small">
                <el-form-item :label="$t('m.t_search')">
                    <el-input :placeholder="$t('m.t_custcode')"  v-model="serchCustNo" clearable>
                    </el-input>
                </el-form-item>
                <el-form-item label="">
                    <el-select v-model="serchSalesId"  filterable clearable :placeholder="this.$t('m.t_salesName')" >
                        <el-option
                                v-for="item in salesList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            <span style="float: left">{{ item.name }}</span>
                            <span style="float: right; color: #8492a6; font-size: 13px;text-align: left;margin-left:10px;">{{ item.loginName }}</span>
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="">
                    <el-input :placeholder="$t('m.t_booking')"  v-model="serchBooking" clearable>
                    </el-input>
                </el-form-item>
                <el-form-item label="">
                    <el-input :placeholder="$t('m.t_site')"  v-model="serchSite" clearable>
                    </el-input>
                </el-form-item>
                <el-form-item >
                    <el-date-picker
                            v-model="getTaskDate"
                            type="date"
                            placeholder="選擇日期">
                    </el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="getTaskList()"><i class="fa fa-search" /> {{$t('m.b_query')}}</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div>
            <el-table :header-cell-style="{background:'#4B78FF',color:'#FFFFFF'}"
                    v-loading="tableloading"
                    @selection-change="handleSelectionChange"
                    :data="custTaskList"
                    :empty-text="$t('m.t_nodata')"
                    stripe
                    border
                    class="dataListTable">

                <el-table-column
                        prop="custNo"
                        align="left"
                        :label="$t('m.t_customer')">
                    <template slot-scope="scope">
                        {{scope.row.custNo}},{{scope.row.custName}}
                    </template>
                </el-table-column>
                <el-table-column
                    prop="salesName"
                    align="left"
                    :label="$t('m.t_salesName')">
                </el-table-column>
                <el-table-column
                        prop="booking"
                        align="left"
                        :label="$t('m.t_booking')">
                </el-table-column>
                <el-table-column
                        prop="site"
                        align="left"
                        :label="$t('m.t_site')">
                </el-table-column>
                <el-table-column
                        prop="taskDate"
                        align="left"
                        :label="$t('m.t_taskDate')">
                    <template slot-scope="scope">
                        <template v-if="scope.row.taskDate!=0">
                            {{scope.row.taskDate*1000 | date('%Y-%m-%d') }}
                        </template>
                    </template>
                </el-table-column>

                <el-table-column
                        prop="id"
                        align="center"
                        width="100"
                        :label="$t('m.b_opt')">
                    <template slot-scope="scope">
                        <template>
                            <el-dropdown>
                                <el-button size="small" type="primary">
                                    <i class="fa fa-mouse-pointer"/> {{$t('m.b_opt')}}
                                </el-button>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item size="small" type="primary" @click.native="taskEdit(scope.$index, scope.row)" v-if="custTaskEdit" ><i class="fa fa-edit"/>{{$t('m.b_edit')}}</el-dropdown-item>
                                    <el-dropdown-item size="small" type="primary" @click.native="deleteTask(scope.$index, scope.row)" v-if="custTaskDelete"><i class="fa fa-trash"/> {{$t('m.t_delete')}}</el-dropdown-item>
                                    <el-dropdown-item size="small" type="primary" @click.native="fileListEdit(scope.row)" v-if="canFile"><i class="fa fa-cloud-upload"/> {{$t('m.t_enclosureadmin')}}</el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </template>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pagination">
            <el-pagination
                    layout="total, prev, pager, next"
                    @current-change="custTaskPageChange"
                    :current-page.sync="pager.page"
                    :page-size="pager.size"
                    :total="pager.total">
            </el-pagination>
        </div>

        <!--&lt;!&ndash;編輯頁面&ndash;&gt;-->
        <el-dialog :title="dialogName" :visible.sync="dialogDiscEditVisible" width="400px">
            <el-form  :model="taskForm"  ref="taskForm" label-width="130px" size="small">
                <el-row :gutter="0">
                    <el-col :span="24">
                        <el-form-item :label="$t('m.t_customer')+'：'" prop="custNo">
                            <el-select v-model="taskForm.custNo" default-first-option valueKey="id"  placeholder="" filterable  remote  :remote-method="itemRemoteMethod"  style="width:200px" @change="custChange">
                                <el-option
                                        v-for="item in custOptions"
                                        :key="item.id"
                                        :label="item.code"
                                        :value="item">
                                    <span style="float: left">{{ item.code }}</span>&nbsp;
                                    <span style="float: right; color: #8492a6; font-size: 13px">{{ item.name }}</span>
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24" >
                        <el-form-item label="銷售員：" prop="salesId">
                            <el-select v-model="taskForm.salesId"  filterable  placeholder=""  style="width:200px;" >
                                <el-option
                                        v-for="item in salesList"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                    <span style="float: left">{{ item.name }}</span>
                                    <span style="float: right; color: #8492a6; font-size: 13px">{{ item.loginName }}</span>
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="任务時間：" prop="taskDate">
                            <el-date-picker
                                    v-model="taskForm.taskDate"
                                    type="date"
                                    placeholder=""
                                    style="width:200px"
                            >
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="搬迁预订:" prop="booking">
                            <el-input v-model="taskForm.booking"  placeholder="" auto-complete="off" style="width:200px" ></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="现场调查:" prop="site">
                            <el-input v-model="taskForm.site"  placeholder="" auto-complete="off" style="width:200px" ></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24" >
                        <el-form-item>
                            <el-button type="primary"  icon="el-icon-check" @click="taskManagementSave" plain>確 定</el-button>
                            <el-button @click="dialogDiscEditVisible = false" icon="el-icon-delete" plain>取 消</el-button>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </el-dialog>

        <!-- 附件管理-->
        <el-dialog :title="dialogFileListName" :visible.sync="dialogFileListVisible" width="80%">
            <div>
                <div style="float:right">
                    <el-button type="warning" @click="custFileAdd" v-if="canFileAdd"><i class="fa fa-cloud-upload" />{{$t('m.b_uploadfile')}}</el-button>
                    <div style="height: 10px"></div>
                </div>
                <el-table :header-cell-style="{background:'#4B78FF',color:'#FFFFFF'}"
                        v-loading="tableloading"
                        @selection-change="handleSelectionFileChange"
                        :data="fileList"
                        :empty-text="$t('m.t_nodata')"
                        stripe
                        border
                        style="width: 100%">
                    <el-table-column
                            prop="fileName"
                            align="left"
                            width="160"
                            :label="$t('m.t_filename')">
                        <template slot-scope="scope">
                            <el-popover trigger="hover" placement="top" v-if="pictureImg(scope.$index, scope.row)">
                                <p><img :src="getImageUrl(scope.$index, scope.row)" style="width: 100px;height: 100px"/></p>
                                <div slot="reference" class="name-wrapper">
                                    <el-tag size="medium"><a href="#" @click="openFile(scope.$index, scope.row)">{{scope.row.fileName}}</a></el-tag>
                                </div>
                            </el-popover>
                            <a href="javascript:void(0)" @click="fileDownload(scope.$index, scope.row)" v-if="canFileDow&&!pictureImg(scope.$index, scope.row)">{{scope.row.fileName}}</a>
                            <span v-if="!canFileDow&&!pictureImg(scope.$index, scope.row)">{{scope.row.fileName}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="comment"
                            align="left"
                            :label="$t('m.t_remarks')">
                    </el-table-column>
                    <el-table-column
                            prop="uploadBy"
                            align="left"
                            width="120"
                            :label="$t('m.t_uploadby')">
                    </el-table-column>
                    <el-table-column
                            prop="tel2"
                            align="left"
                            width="160"
                            :label="$t('m.t_uploadtime')">
                        <template slot-scope="scope">
                            {{scope.row.uploadTime*1000 | date('%Y-%m-%d %T') }}
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="id"
                            align="center"
                            width="100"
                            :label="$t('m.b_opt')" v-if="canFileDow||canFileDel">
                        <template slot-scope="scope">
                            <template>
                                <el-dropdown>
                                    <el-button size="small" type="primary">
                                        <i class="fa fa-mouse-pointer"/> {{$t('m.b_opt')}}
                                    </el-button>
                                    <el-dropdown-menu slot="dropdown">
                                        <el-dropdown-item  @click.native="fileDownload(scope.$index, scope.row)" v-if="canFileDow"><i class="fa fa-download"/> {{$t('m.t_download')}}</el-dropdown-item>
                                        <el-dropdown-item  @click.native="deleteCustFile(scope.$index, scope.row)" v-if="canFileDel"><i class="fa fa-trash"/>{{$t('m.b_delete')}}</el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown>
                            </template>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="pagination">
                <el-pagination
                        layout="total, prev, pager, next"
                        @current-change="handleFileListChange"
                        :current-page.sync="fileListPager.page"
                        :page-size="fileListPager.size"
                        :total="fileListPager.total">
                </el-pagination>
            </div>
            <div style="height: 50px">
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFileListVisible = false">{{$t('m.b_cancel')}}</el-button>
            </div>
        </el-dialog>

        <!-- 附件上傳页面-->
        <el-dialog :title="dialogFileName" :visible.sync="dialogFileVisible" width="400px">
            <el-form  :model="custFile"  :rules="custFileRules" ref="custFile" label-width="100px" size="small">
                <el-row :gutter="0">
                    <el-col :span="24">
                        <el-form-item :label="$t('m.t_file')" prop="file">
                            <div>
                                <a href='javascript:void(0);' class="blueButton">{{$t('m.t_selectthefile')}}</a>
                                <input type="file" id="file" @change="getFile($event)" class="myFileUpload" />
                                <div class="show" id="file_name"></div>
                            </div>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="0">
                    <el-col :span="24">
                        <el-form-item :label="$t('m.t_remarks')" prop="comment">
                            <el-input
                                    type="textarea"
                                    :autosize="{ minRows: 2, maxRows: 4}"
                                    placeholder=""
                                    v-model="custFile.comment">
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFileVisible = false">{{$t('m.b_cancel')}}</el-button>
                <el-button type="primary" @click="custFileSave" :loading="addEidtloading">{{$t('m.b_save')}}</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import axios from 'axios'
    import {getTaskList,getStaffAllList,getCustAllCustMgtList,insertTask,updateTask,getTaskById,deleteTaskById,imageUrl,getCustFileList,deleteCustFile} from '../api/api'
    export default {
        data() {
            var validateFile=(rule, value, callback) => {
                if (value==""){
                    document.getElementById("file_name").innerHTML=this.$t('m.t_selectthefile');
                    callback(new Error(' '));
                }
                callback();
            };
            return {
                pickerOptions0:{
                    disabledDate(time) {
                        return time.getTime() < Date.now() - 8.64e7;
                    }
                },
                //查詢條件
                serchSalesId:"",
                serchCustNo:"",
                serchBooking:"",
                serchSite:'',
                getTaskDate:'',
                selectionItems:[],
                pager:{
                    page:0,
                    size:10,
                    total:0
                },
                custTaskList:[],
                dialogName:'',
                tableloading:false,
                dialogDiscEditVisible:false,
                taskForm:{
                    id:"",
                    custId:'',
                    custNo:'',
                    salesId:"",
                    taskDate:"",
                    booking:'',
                    site:''
                },
                salesList:[],
                custOptions:[],

                returnId:0,
                fileList:[],
                addEidtloading:false,
                dialogFileListVisible:false,
                dialogFileVisible:false,
                dialogFileListName:'',
                dialogFileName:'',
                fileListPager:{
                    page:0,
                    size:10,
                    total:0
                },
                fileId:[],
                oldFileId:[],
                custFile:{
                    file:"",
                    comment:""
                },
                custFileRules: {
                    file:[
                        {required: true, validator: validateFile,trigger: 'change' }
                    ],
                    comment:[
                        {required: false, message: this.$t('m.m_remarks'), trigger: 'change' }
                    ]
                },
            }
        },
        methods: {
            handleSelectionFileChange(){},
            handleFileListChange(val){
                this.getCustFileList();
            },
            getImageUrl(index,row){
                let fileUrl=row.relativePath;
                return imageUrl(fileUrl);
            },
            openFile(index,row){
                let fileUrl=row.relativePath;
                window.open(imageUrl(fileUrl));
            },
            pictureImg(index,row){
                let  url=row.fileUrl;
                let  suffixName=url.substr(url.lastIndexOf(".")).toLowerCase();//获得文件后缀名
                var strFilter=".jpeg|.gif|.jpg|.png|.bmp|.pic|";
                if(strFilter.indexOf(suffixName)>-1){
                    return true;
                }else{
                    return false;
                }
            },

            fileListEdit(value){
                this.dialogFileListName = this.$t('m.t_enclosureadmin');
                this.dialogFileListVisible = true;
                this.returnId=value.id;
                this.getCustFileList();
            },
            getCustFileList(){
                if(this.returnId!="" || this.returnId!=undefined) {
                    var params = {
                        page: this.fileListPager.page,
                        size: this.fileListPager.size,
                        taskId: this.returnId,
                        typeId: 1,
                    };
                    getCustFileList(params).then(data => {
                        let {data:res={}}=data;
                        if(res.errcode==200){
                            let {size,page,total,data:items=[]}=res.data;
                            this.fileList=items;
                            this.fileListPager.total=total;
                            this.fileListPager.page=page;
                            this.fileListPager.size=size;
                            this.tableloading=false;
                        }else {
                            this.$message.error(res.errmsg);
                        }
                    });
                }
            },
            custFileAdd(){
                this.dialogFileName=this.$t('m.b_uploadfile');
                this.dialogFileVisible=true;
                //重置file
                var file = document.getElementById('file');
                if(file!=null||file!=undefined){file.value="";}
                var fileValue=document.getElementById("file_name");
                if (fileValue!=null||fileValue!=undefined){fileValue.innerHTML="";}
                this.resetForm("custFile");
            },
            getFile(event){
                if(event.target.files[0]!=undefined&&event.target.files[0]!=null) {
                    this.custFile.file = event.target.files[0];
                    document.getElementById("file_name").innerHTML = this.custFile.file.name;
                }
            },
            custFileSave(){
                this.$refs.custFile.validate((valid) => {
                    if (valid) {
                        let fileSize=this.custFile.file.size/1024;
                        if (fileSize>50000){
                            this.$message.warning(this.$t('m.b_uploadfileMaxFiftyMb'));
                            return;
                        }

                        //阻止元素发生默认的行为
                        event.preventDefault();
                        var token=JSON.parse(window.sessionStorage.getItem("staff")).token;
                        var paramData = new FormData(); //创建form对象
                        paramData.append("file",this.custFile.file);//通过append向form对象添加数据
                        paramData.append("comment",this.custFile.comment);//通过append向form对象添加数据
                        paramData.append("typeId",1);//通过append向form对象添加数据
                        paramData.append("taskId",this.returnId);//通过append向form对象添加数据*/
                        let config = {
                            headers:{
                                'Content-Type':'multipart/form-data',
                                'Authorization':token
                            }
                        };
                        this.$http.post(axios.defaults.baseURL+'/fileUpload/upload', paramData,config).then(function (res) {
                            let item = res.data;
                            if (item.errcode === 200) {
                                this.$message.success(this.$t('m.m_uploadsuccess'));
                                this.getCustFileList();
                                this.resetForm("custFile");
                                this.dialogFileVisible=false;

                                //重置file
                                var file = document.getElementById('file');
                                file.value='';
                                document.getElementById("file_name").innerHTML="";
                            }
                        })
                    }
                });
            },
            deleteCustFile(index,row){
                this.$confirm(this.$t('m.m_deleteconfirm'),this.$t('m.m_info'), {
                    confirmButtonText:this.$t('m.t_confirm'),
                    cancelButtonText: this.$t('m.b_cancel'),
                    type: 'warning'
                }).then(() => {
                    deleteCustFile(row.id).then(data=>{
                        let {errcode,errmsg}=data.data;
                        if(errcode==200){
                            this.$message.success(this.$t('m.m_deletesuc'));
                            this.getCustFileList();
                        }else{
                            this.$message.error(errmsg);
                        }
                    });
                });
            },
            fileDownload(index,row){
                window.location.href=axios.defaults.baseURL+'/fileDownload?id='+row.id;
            },


            deleteTask(index, row) {
                this.$confirm('你確定要删除任务嗎?',this.$t('m.m_info'), {
                    dangerouslyUseHTMLString: true,
                    confirmButtonText: this.$t('m.t_confirm'),
                    cancelButtonText: this.$t('m.t_cancel'),
                    type: 'warning'
                }).then(()=> {
                    deleteTaskById(row.id).then(data=>{
                        let {data:res={}}=data;
                        if(res.errcode==200){
                            this.$message.success('刪除成功');
                            this.getTaskList();
                        }else{
                            this.$message.error(res.errmsg);
                        }
                    });
                });
            },
            custChange(ev){
                if(ev!="") {
                    this.taskForm.custId = ev.id;
                    this.taskForm.custNo=ev.code;
                }
            },
            isNull(){/*是否为空*/
                if(this.taskForm.custId ==="" || this.taskForm.custId === null){
                    return "客戶編號不能為空"
                }if(this.taskForm.salesId ==="" || this.taskForm.salesId === null){
                    return "銷售員不能為空"
                }
                if(this.taskForm.taskDate ==="" || this.taskForm.taskDate === null){
                    return "任务時間不能為空"
                }
                if(this.taskForm.booking ==="" || this.taskForm.booking === null){
                    return "搬迁预订不能為空"
                }
                if(this.taskForm.site ==="" || this.taskForm.site === null){
                    return "现场调查不能為空"
                }
                return "";
            },

            taskEdit(index, row) {
                this.dialogName="編輯客戶資訊",
                this.dialogDiscEditVisible=true;
                this.resetForm("taskForm");
                this.getTaskById(row.id);
            },
            getTaskById(id){
                return getTaskById(id).then(data=>{
                    let item=data.data;
                    if(item!=null){
                        Object.assign(this.taskForm,item.data);
                        if (item.data.taskDate == 0) {
                            this.taskForm.taskDate = "";
                        } else {
                            this.taskForm.taskDate = new Date(item.data.taskDate * 1000);
                        }
                    }else{
                        this.$message.error(item.errmsg);
                    }
                });
            },
            itemRemoteMethod(query){
                if (query!=""){
                    var params={custNo:query,groupId:this.id};
                    getCustAllCustMgtList(params).then(data=>{
                        let {data:res={}}=data;
                        this.custOptions=res.data;
                    });
                }
            },
            taskManagementSave(){
                this.$refs.taskForm.validate((valid) => {
                    let str = this.isNull();
                    if(str !== ""){
                        this.dialogVisible =true;
                        this.$alert(str, '提示', {
                            confirmButtonText: '確定',
                            type: 'error'
                        });
                    }else {
                        if (valid) {
                            if (this.taskForm.taskDate == null || this.taskForm.taskDate == '') {
                                this.taskForm.taskDate = 0
                            }
                            if (this.taskForm.id == "") {       //新增
                                this.addEidtloading = true;
                                var params = Object.assign({}, this.taskForm);
                                params.taskDate = Math.round(new Date(params.taskDate).getTime() / 1000);
                                insertTask(params).then(data => {
                                    this.addEidtloading = false;
                                    let {data: res = {}} = data;
                                    if (res.errcode == 200) {
                                        this.$message.success("新增成功！！");
                                        this.getTaskList();
                                        this.resetForm("taskForm");
                                        this.dialogDiscEditVisible = false;
                                    } else {
                                        this.$message.error(res.errmsg);
                                    }
                                }, err => {
                                    this.addEidtloading = false;
                                });
                            }else{
                                var params = Object.assign({}, this.taskForm);
                                params.taskDate = Math.round(new Date(params.taskDate).getTime() / 1000);
                                updateTask(params).then(data => {
                                    this.addEidtloading = false;
                                    let {data: res = {}} = data;
                                    if (res.errcode == 200) {
                                        this.$message.success("修改成功");
                                        this.getTaskList();
                                        this.resetForm("taskForm");
                                        this.dialogDiscEditVisible = false;
                                    } else {
                                        this.$message.error(res.errmsg);
                                    }
                                }, err => {
                                    this.addEidtloading = false;
                                });
                            }
                        }
                    }
                });
            },
            addCustTask(){
                this.dialogDiscEditVisible=true;
                this.dialogName=this.$t('m.t_newTask'),
                this.resetForm("taskForm");
            },
            custTaskPageChange(val){
                this.getTaskList();
            },handleItemChange(val){
            },
            handleSelectionChange(val){
                this.selectionItems=val;
            },
            getTaskList(){
                this.tableloading=true;
                var params={page:this.pager.page,size:this.pager.size,custNo:this.serchCustNo,salesId:this.serchSalesId,booking:this.serchBooking,site:this.serchSite,taskDate:this.getTaskDate};
                if(params.taskDate!=null && params.taskDate!=''){
                    params.taskDate = parseInt(new Date(params.taskDate).getTime()/1000);
                }
                return getTaskList(params).then(data=>{
                    let {data:res={}}=data;
                    if(res.errcode==200){
                        let {size,page,total,data:items=[]}=res.data;
                        this.custTaskList=items;
                        this.pager.total=total;
                        this.pager.page=page;
                        this.pager.size=size;
                        this.tableloading=false;
                    }else{
                        this.$message.error(res.errmsg);
                    }
                });
            },
            resetForm(formName){
                if (this.$refs[formName]!==undefined) {
                    this.$refs[formName].resetFields();
                }
            }
        },
        mounted() {
        },
        activated(){
            this.getTaskList();
            getStaffAllList().then(data=>{
                let {data:res={}}=data;
                this.salesList=res.data;
            });
        },
        computed: {
            custTaskAdd(){
                return this.$store.getters.hasPermission("TASK_ADD");
            },
            custTaskEdit(){
                return this.$store.getters.hasPermission("TASK_EDIT");
            },custTaskDelete(){
                return this.$store.getters.hasPermission("TASK_DELETE");
            },
            canFile(){
                return this.$store.getters.hasPermission("TASK_FILE");
            },
            canFileAdd(){
                return this.$store.getters.hasPermission("TASK_FILE_ADD");
            },
            canFileDow(){
                return this.$store.getters.hasPermission("TASK_FILE_DOW");
            },
            canFileDel(){
                return this.$store.getters.hasPermission("TASK_FILE_DEL");
            },
        }
    }

</script>

<style lang="scss">
    .menu{
        .right{
            float: right;
        }
    }
    .el-tag + .el-tag {
        margin-left: 5px;
    }
    .dataListTable .cell{ white-space:nowrap; }
</style>



// WEBPACK FOOTER //
// src/views/TaskList.vue